<div class="layout-footer">
    <img src="assets/logo_long_gray.png" alt="Logo" height="20" class="mr-2"/>
</div>
